"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _hooks = require("../hooks");
var _SearchContext = require("../SearchContext");
var styles = {
  "result": "ListItem__result__1lKKE",
  "children": "ListItem__children__1BrRD",
  "is-section": "ListItem__is-section__2KcYN",
  "isSection": "ListItem__is-section__2KcYN",
  "indicators": "ListItem__indicators__254Wc",
  "item-link": "ListItem__item-link__1TpdG",
  "itemLink": "ListItem__item-link__1TpdG",
  "item-unselected": "ListItem__item-unselected__3dzHB",
  "itemUnselected": "ListItem__item-unselected__3dzHB",
  "item-selected": "ListItem__item-selected__1l_Ue",
  "itemSelected": "ListItem__item-selected__1l_Ue",
  "empty-result": "ListItem__empty-result__1hi9Z",
  "emptyResult": "ListItem__empty-result__1hi9Z"
}; 
require('./ListItem.css');
var ListItem = function ListItem(_ref) {
  var children = _ref.children,
    title = _ref.title,
    path = _ref.path,
    isSection = _ref.isSection;
  var getPortalPath = (0, _exchangeReactHooks.useGetPortalPath)();
  var isCurrentPath = (0, _hooks.useIsCurrentPath)()(path);
  var resultPath = path ? getPortalPath(path) : path;
  var _React$useContext = _react.default.useContext(_SearchContext.AssetPortalSearchContext),
    currentMatch = _React$useContext.currentMatch,
    currentTotalMatches = _React$useContext.currentTotalMatches,
    onNavigate = _React$useContext.onNavigate;
  var linkRef = _react.default.useRef();
  var handleNavigation = _react.default.useCallback(function () {
    onNavigate === null || onNavigate === void 0 || onNavigate({
      path: path
    });
  }, [onNavigate, path]);
  (0, _hooks.useScrollIntoView)(linkRef, isCurrentPath);
  return /*#__PURE__*/_react.default.createElement("li", {
    key: path,
    "data-test-id": "match-item",
    "data-match-id": path
  }, !!path ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: (0, _classnames.default)(styles.itemLink, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.itemSelected, isCurrentPath), styles.itemUnselected, !isCurrentPath)),
    "aria-label": "Navigate to ".concat(title !== null && title !== void 0 ? title : typeof children === 'string' ? children : 'result'),
    to: resultPath,
    ref: linkRef,
    onClick: handleNavigation,
    "data-test-id": "match-link-".concat(path)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.result,
    "data-test-id": "match-name-".concat(path)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(styles.children, (0, _defineProperty2.default)({}, styles.isSection, isSection))
  }, children), isCurrentPath && currentMatch && currentTotalMatches ? /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "search-indicators",
    className: styles.indicators
  }, currentMatch, " of ", currentTotalMatches) : null)) : null, !path ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.emptyResult, styles.children),
    "data-test-id": "empty-match-name"
  }, children) : null);
};
var _default = exports.default = ListItem;
//# sourceMappingURL=ListItem.js.map